import { useEffect, useMemo, useState } from 'react';
import { serverView, serverNeeds, isServerProject } from '@battleops/shared';
import { useLocalDoc } from './useLocal';
import { useProjects } from '../context/ProjectContext';

// The VPS's metrics (opsServer/now — the API writes it every 5 min from the host collector; owners only). Read from the
// local store like every other doc: nothing here touches the network. Re-read once a minute so "4 min ago" moves.

function useMinute() {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => { const iv = setInterval(() => setNow(Date.now()), 60000); return () => clearInterval(iv); }, []);
  return now;
}

/** → { doc, view } — view null when the doc isn't on this device (not an owner, or no collector yet). */
export function useServerMetrics() {
  const doc = useLocalDoc('server', 'now');
  const now = useMinute();
  const view = useMemo(() => serverView(doc, now), [doc, now]);
  return { doc, view };
}

/** The view when `project` is the server's project (the doc's projectId, else a project named VPS), else null. */
export function useServerFor(project) {
  const { doc, view } = useServerMetrics();
  return project && isServerProject(project, doc) ? view : null;
}

/** Needs you rows for the All Home: disk < 10 % free, a container down, the backup > 8 days old. */
export function useServerNeeds() {
  const { doc, view } = useServerMetrics();
  const { projects } = useProjects();
  return useMemo(() => {
    if (!view) return [];
    const project = (projects || []).find((p) => isServerProject(p, doc)) || null;
    return serverNeeds(view, project);
  }, [view, doc, projects]);
}
